/*
 * @Author: YH000644 weirongwei@danghuan.com
 * @Date: 2024-12-03 12:07:17
 * @LastEditors: YH000644 weirongwei@danghuan.com
 * @LastEditTime: 2024-12-18 11:28:46
 * @FilePath: \eu-eswop-official-site\src\services\axios.js
 * @Description:
 */ 1;
import axios from 'axios';
import md5 from 'js-md5';
import CryptoJS from 'crypto-js';
import { isDev } from '@/utils/config.js';
import { Message, Loading } from 'element-ui';
import router from '@/router';

const baseURL = isDev ? '/api' : '';
import { customRequestHeader } from '@/locales';

let ts = Date.now();

const hash = window.location.hash; // "#/page?nationCode=CH&channelId=114030"
const queryString = hash.split('?')[1]; // "nationCode=CH&channelId=114030"
const urlParams = new URLSearchParams(queryString);

const channelId = urlParams.get('channelId') || '100030';
const nationCode = urlParams.get('nationCode') || 'GB';

let loadingInstance = null; // 存储 Loading 实例

// 对象按照属性排序并拼接成字符串
const sortAndJoinObjectProperties = params => {
  let str = '';
  Object.keys(params)
    .sort()
    .forEach(key => {
      // console.log(params[key], '----params[key]-----')
      if (key === 'optionIds') {
        str += key + '=' + '[' + params[key].join(', ') + ']' + '&';
      } else if (params[key]) {
        str += key + '=' + params[key] + '&';
      }
    });
  return str.slice(0, -1);
};

const service = axios.create({
  baseURL,
  headers: {
    channelId,
    ts,
    nationCode,
    // sign: md5(channelId + secretKey + ts),
    'Accept-Language': customRequestHeader['Accept-Language']
  },
  timeout: 20000
});

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 开始 Loading
    loadingInstance = Loading.service({
      lock: true,
      text: '加载中...',
      background: 'transparent' // 透明背景
    });

    const dateTs = Date.now();
    const { data, headers, url } = config;
    headers['ts'] = dateTs;

    if (url.includes('customer')) {
      let params = {};
      if (data) {
        Object.assign(params, data);
      } else {
        Object.assign(params, config.params);
      }
      params['nationCode'] = nationCode;
      params['channelId'] = channelId;
      params['ts'] = dateTs;
      const secret = md5('europe@pc@h5@1#@7wllee57');
      const hmac = CryptoJS.HmacSHA256(sortAndJoinObjectProperties(params), secret);
      headers['sign'] = hmac.toString(CryptoJS.enc.Hex);
    }
    return config;
  },
  error => {
    if (loadingInstance) loadingInstance.close();
    // 请求错误处理
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  response => {
    if (loadingInstance) loadingInstance.close();
    // 响应后处理 && response.data.code === '0000'
    console.log('responseresponse', response);
    if (response.status === 200) {
      return Promise.resolve(response.data);
    } else {
      return Promise.reject(response.data);
    }
  },
  error => {
    if (loadingInstance) loadingInstance.close();
    if (error?.response?.data?.message) {
      Message({
        message: error?.response?.data?.message,
        type: 'error'
      });
    }

    return Promise.reject(error);
  }
);

export default service;
